/**
 *
 * Asynchronously loads the component for NinjaPackOrderCreate
 *
 */

import { PageLoading } from 'components/Loading'
import React from 'react'
import loadable from 'utils/loadable'

export default loadable({
  loader: () => import('./index'),
  loading: <PageLoading />
})
